export const NWMonogram = ({ className = "h-10 w-auto" }) => (
  <svg viewBox="0 0 96 64" fill="none" className={className} aria-label="Northwest Tech Alliance monogram">
    {/* N — evergreen / mountain */}
    <path d="M4 60V8h9l18 32V8h9v52h-9L13 28v32H4z" fill="#1B4332" />
    <path d="M13 8l9 16-4.5-8L13 8z" fill="#2D6A4F" />
    <path d="M4 8h9l4 7-6.5-7H4z" fill="#26A875" opacity="0.8" />
    {/* W — circuit traces */}
    <path d="M46 8l8 34 6-20h4l6 20 8-34h7l-11 52h-8l-6-19-6 19h-8L39 8h7z" fill="#2176C7" />
    <path d="M64 22h4l-2 9h-4l2-9z" fill="#0B2545" opacity="0.35" />
    <circle cx="88" cy="10" r="3" stroke="#38bdf8" strokeWidth="1.6" fill="none" />
    <path d="M85 12l-6 6" stroke="#38bdf8" strokeWidth="1.6" />
    <circle cx="90" cy="26" r="2.4" stroke="#38bdf8" strokeWidth="1.4" fill="none" />
    <path d="M87.6 24.5L80 18" stroke="#38bdf8" strokeWidth="1.4" />
  </svg>
);

export const WashingtonSilhouette = ({ className = "h-5 w-auto" }) => (
  <svg viewBox="0 0 100 62" fill="none" className={className} aria-label="Washington state outline">
    <path
      d="M20 6 L92 6 L91 44 C84 51 76 47 68 51 C60 55 52 58 44 53 C36 48 30 50 24 53 L12 43 C10 35 8 29 10 23 L5 14 L24 10 L28 15 L26 23 L30 28 L33 21 L31 11 L20 8 Z"
      fill="rgba(33,118,199,0.12)"
      stroke="#38bdf8"
      strokeWidth="2"
      strokeLinejoin="round"
    />
  </svg>
);

export const LogoLockup = ({ compact = false }) => (
  <div className="flex items-center gap-3" data-testid="logo-lockup">
    <img
      src="/assets/nwta-monogram.png"
      alt="Northwest Tech Alliance monogram"
      className={compact ? "h-9 w-auto" : "h-11 w-auto"}
    />
    <div className="leading-none">
      <div className="font-display font-700 tracking-[0.18em] text-[13px] font-bold text-fog">
        NORTHWEST
      </div>
      <div className="font-display tracking-[0.1em] text-[11px] font-medium text-tech-bright">
        TECH ALLIANCE
      </div>
    </div>
  </div>
);
